export { DOMOverlayRenderer } from './dom-modal-renderer';
export { Modal } from './modal';
export { DOMOutsideEventPlugin } from './outside-event-plugin';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-modal/esm/providers/index.js
// module id = 55
// module chunks = 3